module.exports = __webpack_public_path__ + "static/media/check.606046e6.png";